// extracted by mini-css-extract-plugin
export default {"container":"EventColorInput_container__+Po8-","colorInput":"EventColorInput_colorInput__V-6kI","label":"EventColorInput_label__Am+0N","value":"EventColorInput_value__stK2g"};